// API Configuration
// This file centralizes all API endpoint URLs

// Base URL for Netlify Functions
// In production, this will be your Netlify site URL
// In development, you can use 'http://localhost:8888' if running netlify dev
const BASE_URL = process.env.REACT_APP_API_URL || '/.netlify/functions';

export const API_ENDPOINTS = {
  // Authentication
  SIGNIN: `${BASE_URL}/signin`,
  SAVE_USER: `${BASE_URL}/saveUser`,
  CREATE_PASSWORD: `${BASE_URL}/createPassword`,
  RESET_PASSWORD: `${BASE_URL}/resetPassword`,
  CHECK_USER: `${BASE_URL}/checkUser`,

  // Deriv API
  GET_BALANCE: `${BASE_URL}/getBalance`,
  GET_TRANSACTIONS: `${BASE_URL}/getTransactions`,
  GET_TRANSACTION_SUMS: `${BASE_URL}/getTransactionSums`,
  GET_EXCHANGE_RATE: `${BASE_URL}/getExchangeRate`,
  GET_WITHDRAW_EXCHANGE_RATE: `${BASE_URL}/getWithdrawExchangeRate`,

  // M-Pesa
  STK_PUSH: `${BASE_URL}/stkPush`,
  CHECK_TRANSACTION_STATUS: `${BASE_URL}/checkTransactionStatus`,
  SEND_VERIFICATION_EMAIL: `${BASE_URL}/sendVerificationEmail`,
  WITHDRAW: `${BASE_URL}/withdraw`,

  // OAuth & Admin
  OAUTH_CALLBACK: `${BASE_URL}/oauth-callback`,
  RETRY_FAILED_JOBS: `${BASE_URL}/retry-failed-jobs`,
};

export default API_ENDPOINTS;
